import React from 'react';
import styled from '@emotion/styled';

const JobTimerIcon = ({ ready = false }) => (
  <FaceDiv ready={+ready}>
    <TickDiv />
    <StaTickDiv />
  </FaceDiv>
);

export default JobTimerIcon;

const FaceDiv = styled.div<{ ready: number }>`
  width: 18px;
  height: 18px;
  border-radius: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ ready, theme }) => (ready ? theme.palette.info.main : theme.palette.warning.main)};
`;

const TickDiv = styled.div`
  width: 12px;
  height: 2px;
  background: ${({ theme }) =>
    `linear-gradient(to right,  rgba(255,255,255,0) 0%,rgba(255,255,255,0) 44%,${theme.palette.background.paper} 45%,${theme.palette.background.paper} 100%)`};
  animation: tick 12s linear infinite;

  @keyframes tick {
    0% {
      transform: rotate(0deg);
    }
    8% {
      transform: rotate(30deg);
    }
    16% {
      transform: rotate(40deg);
    }
    24% {
      transform: rotate(90deg);
    }
    33% {
      transform: rotate(120deg);
    }
    42% {
      transform: rotate(150deg);
    }
    50% {
      transform: rotate(180deg);
    }
    58% {
      transform: rotate(210deg);
    }
    65% {
      transform: rotate(240deg);
    }
    74% {
      transform: rotate(270deg);
    }
    83% {
      transform: rotate(300deg);
    }
    92% {
      transform: rotate(330deg);
    }
    100% {
      transform: rotate(340deg);
    }
  }
`;

const StaTickDiv = styled.div`
  position: absolute;
  width: 10px;
  border-radius: 3px;
  height: 2px;
  background: ${({ theme }) =>
    `linear-gradient(to right,  rgba(255,255,255,0) 0%,rgba(255,255,255,0) 44%,${theme.palette.background.paper} 45%,${theme.palette.background.paper} 100%)`};
  transform: rotate(270deg);
`;
